import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@capturi/ui-components'
import { BaseModalComponentProps } from '@capturi/use-modal'
import { Box, Text } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useViewSftpUsers } from '../../../useManageSftp'

type Props = {
  organizationUid: string
  userUid: string
  username: string
} & BaseModalComponentProps

export const ViewPassword: React.FC<Props> = ({
  onClose,
  organizationUid,
  userUid,
  username,
}) => {
  const [view, setView] = useState(false)
  const { data, isLoading, error } = useViewSftpUsers(
    {
      organizationUid,
      userUid,
    },
    { enabled: view },
  )

  return (
    <Modal isOpen onClose={onClose}>
      <ModalOverlay>
        <ModalContent>
          <ModalHeader>Password</ModalHeader>

          <ModalCloseButton />
          <ModalBody justifyContent="center" display="flex">
            <Button primary onClick={() => setView(true)} isLoading={isLoading}>
              View Password
            </Button>
            {error && <Text color="danger">{error.message}</Text>}
            {data && (
              <Box
                mt="2"
                p="2"
                bg="gray.100"
                borderRadius="md"
                userSelect="all"
                fontFamily="mono"
              >
                <Text>{username}</Text>
                <Text>{data.password}</Text>
              </Box>
            )}
          </ModalBody>
          <ModalFooter justifyContent="flex-end">
            <Button primary variant="ghost" onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </ModalOverlay>
    </Modal>
  )
}
